import React from 'react';
import {useSelector} from "react-redux";
import {getRowNumber} from "mindsets-js-sdk";

import Row from './Row';

export default function () {
    const curricula = useSelector(state => state.schools_curricula);
    const items = useSelector(state => state.schools);
    const current = useSelector(state => state.schools_current);
    const limit = useSelector(state => state.schools_limit);

    return (
        <div className="table-responsive">
            <table className="table table-bordered table-hover">
                <thead>
                <tr className="text-center">
                    <th scope="col">No</th>
                    <th scope="col"><div>ID</div><div>(NCES ID)</div></th>
                    <th scope="col">School Name</th>
                    <th scope="col">Location</th>
                    <th scope="col">Curriculum</th>
                    <th scope="col">No. teacher accounts</th>
                    <th scope="col">No. students joined</th>
                    <th scope="col">No. Classes created</th>
                    <th scope="col">
                        <div>School Plan</div>
                        <div>(Subscription Period)</div>
                    </th>
                    <th scope="col">
                        <div>District Plan</div>
                        <div>(Subscription Period)</div>
                    </th>
                    <th scope="col">Created by/on</th>
                    <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                {items.map((item, index) => {
                    return (
                        <Row
                            key={item.id}
                            item={item}
                            curriculum={curricula.find(curriculum => curriculum.id === item.curriculum_id)}
                            row_number={getRowNumber(index, current, limit)}
                        />
                    );
                })}
                </tbody>
            </table>
        </div>
    );
};
